<div class="border-0 rounded-5 p-3 text-xs">
  <div
    class="custom-scroll-container"
    :class="{ 'custom-scroll-container--locked': table_fits_container }"
  >
    <div
      class="table-responsive"
      :class="{ 'table-responsive--locked': table_fits_container }"
    >
      <table
        :id="table_id"
        class="table table-hover"
        :class="{
          'dt-responsive': responsive,
          'global-table-wide': !responsive,
          'global-table-fit': table_fits_container
        }"
      >
        <thead class="custom-header">
          <tr>
            <th
              v-for="header in headers"
              :key="header"
              :data-col="get_column_id(header)"
              class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3"
              :class="{ 'global-table-toggleable-header': enable_column_toggle && is_toggleable_column(header) }"
              :title="enable_column_toggle && is_toggleable_column(header) ? 'Click to hide column' : ''"
            >
              <span class="global-table-header-label">{{ header }}</span>
              <i
                v-if="enable_column_toggle && is_toggleable_column(header)"
                class="bi bi-eye-slash global-table-header-icon"
                aria-hidden="true"
              ></i>
            </th>
            <th v-if="$slots.actions" class="text-uppercase text-xxs font-weight-bolder opacity-7">
              Action
            </th>
            <th v-if="$slots.assign" class="text-uppercase text-xxs font-weight-bolder opacity-7">
              Assign
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="(!Array.isArray(data) || data.length === 0) && !is_initializing">
            <td :colspan="headers.length + ($slots.actions ? 1 : 0) + ($slots.assign ? 1 : 0)" class="text-xxs text-muted">
              No matching records available
            </td>
          </tr>
          <template v-else>
            <tr v-for="(row, index) in data" :key="get_row_key(row, index)">
              <td
                v-for="header in headers"
                :key="`${get_row_key(row, index)}-${header}`"
                :data-col="get_column_id(header)"
                class="text-xxs text-start global-table-cell"
                :class="get_cell_class(header)"
                :title="get_cell_title(get_row_value(row, header))"
              >
                <span
                  v-if="is_boolean_indicator(get_row_value(row, header))"
                  class="badge rounded-pill text-xxs fw-semibold"
                  :class="get_indicator_badge_class(get_row_value(row, header))"
                >
                  {{ get_cell_primary_value(get_row_value(row, header)) }}
                </span>
                <span
                  v-if="is_boolean_indicator(get_row_value(row, header)) && get_cell_details_value(get_row_value(row, header))"
                  class="global-table-cell-details"
                >
                  {{ get_cell_details_value(get_row_value(row, header)) }}
                </span>
                <span v-else-if="!is_boolean_indicator(get_row_value(row, header))" class="global-table-cell-details">
                  {{ format_row_value(get_row_value(row, header)) }}
                </span>
              </td>
              <td v-if="$slots.actions" class="text-start">
                <div class="d-flex gap-3">
                  <slot name="actions" :row="row"></slot>
                </div>
              </td>
              <td v-if="$slots.assign" class="text-start">
                <div class="d-flex gap-3">
                  <slot name="assign" :row="row"></slot>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>

  <div
    v-if="enable_column_toggle && get_hidden_columns().length"
    class="global-table-hidden-columns"
  >
    <span class="global-table-hidden-columns__label">Hidden columns - click to restore</span>
    <div class="global-table-hidden-columns__chips">
      <button
        v-for="column in get_hidden_columns()"
        :key="column.id"
        type="button"
        class="global-table-hidden-columns__chip"
        @click="restore_column(column.id)"
      >
        {{ column.label }}
      </button>
    </div>
  </div>
</div>
